import Base from './Base';

class Group extends Base {
  constructor(config = {}) {
    super();

    this.load(config);
  }

  load(config = {}) {
    this.config = config;
    return this;
  }

  getId() {
    return this.config.key;
  }

  // This just allows initDependencies to work in Validate
  getDataSize() {
    return 1;
  }

  /**
   * Checks to see if the group is hidden
   * @return {Boolean}
   */
  isHidden() {
    if (
      this.dependencyActions[0] &&
      (this.dependencyActions[0].includes('hide') || this.dependencyActions[0].includes('disable'))
    ) {
      return true;
    }

    return false;
  }

  report() {
    return {
      config: this.config,
      dependencyActions: this.dependencyActions,
      dependencyIndex: this.dependencyIndex,
    };
  }
}

export default Group;
